import { Column, Flex, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import gotuMonogram from '~/images/logos/logoLightIcon.svg';
import { TestimonialsCarousel } from './TestimonialsCarousel';
import type { ITestimonial, IValueProp } from './types';

export interface IAuthLeftPanelProps {
  headline: { lineOne: string; lineTwo: string };
  valueProps: IValueProp[];
  testimonials: ITestimonial[];
  autoPlayMs?: number;
}

const PANEL_PADDING = '62px 84px 40px 84px';
const TAGLINE_TO_VALUE_PROPS_GAP = 51;
const VALUE_PROPS_TO_TESTIMONIAL_GAP = 60;
const VALUE_PROP_INTERNAL_GAP = 10;

export const AuthLeftPanel = ({
  headline,
  valueProps,
  testimonials,
  autoPlayMs,
}: IAuthLeftPanelProps) => (
  <Column
    height="100%"
    className="bg-gradient-brand-dark"
    style={{ padding: PANEL_PADDING }}
    data-testid="auth-left-panel"
  >
    <Row gap={6} align="center">
      <img src={gotuMonogram} alt="" width={110} height={112} />
      <Typography variant="h4" as="h1" color={colors.shades[0]}>
        <span style={{ display: 'block' }}>{headline.lineOne}</span>
        <span style={{ display: 'block', color: colors.secondary[500] }}>{headline.lineTwo}</span>
      </Typography>
    </Row>

    <Column gap={VALUE_PROP_INTERNAL_GAP} style={{ marginTop: TAGLINE_TO_VALUE_PROPS_GAP }}>
      {valueProps.map((vp, index) => (
        <Row key={index} align="start" gap={4}>
          <Flex style={{ color: colors.shades[0], flexShrink: 0 }}>{vp.icon}</Flex>
          <Typography
            size="heading_4"
            color={colors.shades[0]}
            style={{ marginTop: 4, lineHeight: 1.25 }}
          >
            {vp.text}
          </Typography>
        </Row>
      ))}
    </Column>

    <div
      style={{
        width: '100%',
        marginTop: VALUE_PROPS_TO_TESTIMONIAL_GAP,
      }}
    >
      <TestimonialsCarousel testimonials={testimonials} autoPlayMs={autoPlayMs} />
    </div>
  </Column>
);
